'use client';
import * as React from 'react';
const NavCategoryItemContext = React.createContext(undefined);
const NavCategoryItemContextDefaultValues = {
    open: false
};
export const { Provider: NavCategoryItemProvider } = NavCategoryItemContext;
export const useNavCategoryItemContext_unstable = ()=>{
    var _React_useContext;
    return (_React_useContext = React.useContext(NavCategoryItemContext)) !== null && _React_useContext !== void 0 ? _React_useContext : NavCategoryItemContextDefaultValues;
};
